import { observable, action, computed } from 'mobx';

import config from 'config';
import HttpClient from 'utils/httpclient';

const SAVING = 'SAVING';
const SAVED = 'SAVED';
const LOADING = 'LOADING';
const LOADED = 'LOADED';
const CREATING = 'CREATING';

class BaseStore {
  @observable collection = {
    objects: [],
    pageSize: 10,
    currentPage: 1,
    count: 0,
    readyState: LOADED,
  };

  @observable entity = {
    object: null,
    readyState: LOADED
  };

  constructor(collectionName, entityName, options) {
    this.collectionName = collectionName;
    this.entityName = entityName;
    this.options = options;
    this.collectionURL = `${config.api}/${this.collectionName}`;
    this.collectionURLAll = `${config.api}/${this.collectionName}/all`;
  }

  @action getCurrentSiteID() {
    if (this.options && this.options.site_selection) {
      let site = JSON.parse(localStorage.getItem('site'));
      site = site ? site.id : 0;
      this.collectionURL = `${config.api}/site/${site}/${this.collectionName}`;
      this.collectionURLAll = `${config.api}/site/${site}/${this.collectionName}`;
      return site;
    } else if (this.options && this.options.site_model) {
      let site = JSON.parse(localStorage.getItem('site'));
      return site ? site.id : 0;
    }

    return null;
  }

  @action fetch(id, sendSiteId) {
    this.entity.readyState = LOADING;
    const params = sendSiteId ? { siteId: this.getCurrentSiteID() } : {}
    return HttpClient.get(`${config.api}/${this.entityName}/${id}`, { params })
      .then(action(response => {
        this.entity.object = response.data;
        this.entity.readyState = LOADED;
        return response;
      }));
  }

  @action list(query) {
    query.site_id = this.getCurrentSiteID()
    const params = { params: query };
    this.collection.readyState = LOADING;
    return (
      HttpClient.get(this.collectionURL, params)
        .then(action(response => {
          const data = response.data;
          this.collection.objects = data.rows || [];
          this.collection.count = data.total || 0;
          this.collection.readyState = LOADED;

          return response;
        }))
        .catch(response => {
          this.collection.readyState = LOADED;
          throw response;
        })
    )
    // const params = { params: { page: parameters.page, pageSize: this.collection.pageSize } };
    // if (parameters.term) {
    //   params.params.q = parameters.term;
    // }
    // if (parameters.sort) {
    //   params.params.order = parameters.sort.order;
    //   params.params.direction = parameters.sort.direction;
    // }
    // this.collection.readyState = LOADING;
    // this.getCurrentSiteID();
    // return (
    //   HttpClient.get(this.collectionURL, params)
    //   .then(action(response => {
    //     const list = response.data;
    //     let objects = this.collection.objects;
    //     this.collection.objects = objects.concat(list[this.collectionName]);
    //     this.collection.pageSize = list.pageSize;
    //     this.collection.currentPage = list.currentPage;
    //     this.collection.count = list.count;
    //     this.collection.readyState = LOADED;
    //     return response;
    //   }))
    // );
  }

  attachFilter = (query = {}, { labelKey = "name", valueKey = 'id', labelFormater = (name, id) => `[#${id}] ${name}` } = {}) => {
    return async () => {
      const store = await this.all(query)
      const options = store.data.map(({ [valueKey]: id, [labelKey]: name }) => { return { value: id, label: labelFormater(name, id) } })

      return { options };
    }
  }

  @action all(query) {
    const params = query || {}

    this.collection.readyState = LOADING;
    let siteId = this.getCurrentSiteID();

    if (siteId && siteId > 0)
      params.site_id = siteId

    return (
      HttpClient.get(this.collectionURLAll, { params })
        .then(action(response => {
          const list = response.data;
          this.collection.objects = list;
          this.collection.count = list.length;
          this.collection.readyState = LOADED;
          return response;
        }))
        .catch(e => {
          this.collection.readyState = LOADED;
        })
    );
  }

  @action resetCollection() {
    this.collection.objects = [];
    this.collection.currentPage = 1;
    this.collection.count = 0;
    this.collection.readyState = LOADED;
  }

  @action resetEntity() {
    this.entity.object = null;
    this.entity.readyState = LOADED;
  }

  @action save(object, params) {
    const method = object.id ? 'put' : 'post';

    let siteId = this.getCurrentSiteID();
    if (siteId && siteId > 0) {
      if (this.options && this.options.site_model)
        object.site_id = siteId

      object.siteId = siteId
    }

    this.entity.readyState = SAVING;
    return HttpClient[method](`${config.api}/${this.entityName}/${object.id || ''}`, object, { params })
      .then(action(response => {
        this.entity.object = object;
        this.entity.readyState = LOADED;
        return response;
      })).catch(response => { throw response });
  }

  @action updateField(id, key, value, extraParams) {
    let object = { id: id };
    object[key] = value;

    if (extraParams) {
      object = Object.assign(object, extraParams);
    }

    return this.save(object);
  }

  @action delete(object, sendSiteId) {
    let params = sendSiteId ? { siteId: this.getCurrentSiteID() } : {}
    if (object.params) params = { ...params, ...object.params }
    return HttpClient.delete(`${config.api}/${this.entityName}/${object.id || ''}`, { params })
      .then(response => response).catch(response => { throw response });
  }

  @computed get hasNextPage() {
    return this.collection.objects.length < this.collection.count;
  }

  @computed get showing() {
    return (this.collection.objects && this.collection.objects.length) || 0;
  }

  @computed get actives() {
    return (this.collection.objects && this.collection.objects.filter(obj => (obj.active || obj.status)).length) || 0;
  }

  @computed get isLoading() {
    return this.collection.readyState === LOADING;
  }

  @computed get isLoaded() {
    return this.collection.readyState === LOADED;
  }
}

export default BaseStore;
export {
  SAVING,
  SAVED,
  LOADING,
  LOADED,
  CREATING
};
